import { render } from "./loadingScreen.vue?vue&type=template&id=613d7ad4&scoped=true"
import script from "./loadingScreen.vue?vue&type=script&lang=js"
export * from "./loadingScreen.vue?vue&type=script&lang=js"

import "./loadingScreen.vue?vue&type=style&index=0&id=613d7ad4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613d7ad4"]])

export default __exports__